import { Form } from "antd";
import { successNotification } from "../../../../helpers/successNotification";
import useFetchData from "../../../../hooks/useFetchData";
import { CounterpartyAgreementDtoRequest, CounterpartyAgreementDtoResponse } from "../../../../interfaces/CounterpartyDtos";
import { CounterpartyService } from "../../../../services/CounterpartyService";
import { formDataMapper } from "../../../../common/file/formDataMapper";
import { FileService } from "../../../../services/file/FileService";

const useCounterpartyAgreement = () => {
    const { data: agreements, fetchData: fetchAgreements, isLoading: loading } = useFetchData<CounterpartyAgreementDtoResponse[]>(CounterpartyService.getCounterpartyAgreements, true);
    const [agreementForm] = Form.useForm();

    const handleAdd = (values: CounterpartyAgreementDtoRequest) => {
        const formData = formDataMapper({
            ...values,
            endDate: values.endDate ? values.endDate : "",
        });

        CounterpartyService.createCounterpartyAgreement(formData)
            .then(() => {
                successNotification('Контрагент успешно добавлен!');
                fetchAgreements();
            });
    }

    const handleEdit = (id: number, values: CounterpartyAgreementDtoRequest) => {
        const formData = formDataMapper({
            ...values,
            endDate: values.endDate ? values.endDate : "",
        });

        CounterpartyService.updateCounterpartyAgreement(id, formData)
            .then(() => {
                successNotification('Контрагент успешно изменен!');
                fetchAgreements();
            });
    }

    const handleDelete = (id: number) => {
        CounterpartyService.deleteCounterpartyAgreement(id)
            .then(() => {
                successNotification('Контрагент успешно удален!');
                fetchAgreements();
            });
    }

    const handleDownload = (fileId: number) => {
        return FileService.getFileById(fileId, `CounterpartyAgreement_${fileId}`)
            .then((res) => successNotification("File successfully downloaded!"));
    }

    return { agreements, agreementForm, fetchAgreements, loading, handleAdd, handleEdit, handleDelete, handleDownload };
}

export default useCounterpartyAgreement